module.exports = __webpack_public_path__ + "static/screen-reporting-5ca5209fa53fe03c3f4611a38a0f3767.png";